import superagent from 'superagent';

export default function RolloverController(component, direction, spaceRequired) {
    this._component = component;
    this._direction = direction || 'right';
    this._spaceRequired = spaceRequired;

    this.getInitialState = function() {
        return { rollover: false };
    };

    this.showRollover = function(apiUrl) {
        if (this._component.state.data) {
            this._component.setState({ rollover: true, data: this._component.state.data });
        } else if (!this.requestInProgress) {
            this.requestInProgress = true;
            superagent.get(apiUrl, (error, response) => {
                if (error) {
                    console.log('error', error); // TODO
                }
                const result = response.body;
                this.requestInProgress = false;
                this._component.setState({ rollover: !this.rolloverCancelled, data: result.data });
            });
        }
    };

    this._setDirectionInfo = function() {
        this.directionInfo = {
            direction: this._direction
        };
        const element = this._component.refs.element;
        if (element && window) {
            const box = element.getBoundingClientRect();
            const space = {
                above: box.top,
                below: window.innerHeight - box.bottom,
                left: box.left,
                right: window.innerWidth - box.right
            };
            if (this._direction === 'bottom') {
                if (space.below < space.above) {
                    this.directionInfo.direction = 'top';
                }
                if (space.right < space.left && space.right < this._spaceRequired) {
                    this.directionInfo.slideLeft = true;
                }
            } else if (space.below < space.above && space.below < this._spaceRequired) {
                this.directionInfo.slideUp = true;
            }
        }
    };

    this.onMouseEnter = (apiUrl) => {
        this._setDirectionInfo();
        if (this.leaveTimer) {
            clearTimeout(this.leaveTimer);
            this.leaveTimer = undefined;
            return;
        }
        this.enterTimer = setTimeout(() => {
            this.showRollover(apiUrl);
            this.enterTimer = undefined;
        }, 500);
    };

    this.onMouseLeave = () => {
        if (this.enterTimer) {
            clearTimeout(this.enterTimer);
            this.enterTimer = undefined;
            return;
        }
        if (this.requestInProgress) {
            this.rolloverCancelled = true;
            return;
        }
        this.leaveTimer = setTimeout(() => {
            this.leaveTimer = false;
            this._component.setState({ rollover: false, data: this._component.state.data });
        }, 500);
    };
}



// WEBPACK FOOTER //
// ./src/components/RolloverController.js